<template>
  <div class="root">
    <div class="mb-4">
      <column-chart
        class="print-hide"
        :library="chartOptions"
        :data="chartData"
        :dataset="{ borderWidth: 0 }"
        :download="true"
        :colors="['rgba(63, 174, 215, 1)']"
        :legend="false"
        width="100%"
        height="200"
      />
      <ul class="print-data-list print-only-inline">
        <li v-for="(v, k) in chartData[0].data" :key="k">
          {{ k }} <strong>{{ v }}</strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import Vue from 'vue';
import Chartkick from 'vue-chartkick';

Vue.use(Chartkick.use(Chart));

export default {
  name: 'RegistrationsOverTimeChart',

  props: {
    binnedFrom: {
      type: String,
      default: () => null
    },
    through: {
      type: String,
      default: () => null
    },
    binBy: {
      type: String,
      required: true
    },
    binnedRegistrations: {
      type: Array,
      default: () => {}
    }
  },

  computed: {
    chartOptions() {
      return {
        animation: {
          easing: 'easeOutQuad',
          duration: 400
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        scales: {
          xAxes: [
            {
              offset: true,
              type: 'time',
              time: {
                unit: this.binBy,
                isoWeekday: true,
                displayFormats: { week: 'MMM D' }
              },
              gridLines: {
                display: false
              },
              display: true,
              ticks: {
                min: this.binnedFrom,
                max: this.through,
                fontSize: 15,
                fontColor: '#6B6E88'
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontSize: 15,
                fontColor: '#6B6E88'
              }
            }
          ]
        }
      };
    },

    chartData() {
      return [
        {
          name: 'Registrations',
          data: this.binnedRegistrations.reduce(
            (a, e) => ({ ...a, [e.date]: e.count }),
            {}
          )
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  width: 100%;
  padding: 0 2.45rem;
}
</style>
